import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';

import PublicPagesTrim from 'js/src/components/common/public-pages/PublicPagesTrim';
import PricingPage from 'js/src/components/pricing';
import { getPricingRootReducer } from 'js/src/entry-points/root-reducers/pricing-reducers';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import { createReduxStore, renderWithRedux } from 'js/src/libs/redux-utils';

ErrorReporter.init(Project.FRONTEND);

const PricingPageContainer = React.memo(function PricingPageContainer() {
    return (
        <PublicPagesTrim headerBackgroundColor={'#FFF'}>
            <PricingPage />
        </PublicPagesTrim>
    );
});

const store = createReduxStore(getPricingRootReducer());
renderWithRedux(PricingPageContainer, store);
